import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

export const AppTheme = {
  LIGHT: 'light-theme',
  DARK: 'dark-theme',
  OCEAN: 'ocean-theme'
}

export const useThemeStore = defineStore('theme', () => {
  const currentTheme = ref<string>(AppTheme.LIGHT)

  const appClasses = computed(() => ({
    linexo: true,
    [currentTheme.value]: true
  }))

  function updateTheme(key: keyof typeof AppTheme) {
    currentTheme.value = AppTheme[key]
  }

  return {
    currentTheme,
    appClasses,
    updateTheme
  }
})
